import { render, staticRenderFns } from "./AdminSection.vue?vue&type=template&id=85a9fa96&scoped=true"
import script from "./AdminSection.vue?vue&type=script&lang=js"
export * from "./AdminSection.vue?vue&type=script&lang=js"
import style0 from "./AdminSection.vue?vue&type=style&index=0&id=85a9fa96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a9fa96",
  null
  
)

export default component.exports